import React from 'react';
import { useFetchVotes } from '../../hooks/DataFetching/useFetchVotes';

export const FetchVotes = () => {
  const { votes, loading } = useFetchVotes();

  const renderVotesTable = (votes) => {
    return (
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>Id</th>
            <th>CampaignId</th>
            <th>UserId</th>
            <th>Vote1</th>
            <th>VoteReason</th>
            <th>CreatedOn</th>
          </tr>
        </thead>
        <tbody>
          {votes.map(vote =>
            <tr key={vote.id}>
              <td>{vote.id}</td>
              <td>{vote.campaignId}</td>
              <td>{vote.userId}</td>
              <td>{String(vote.vote1)}</td>
              <td>{vote.voteReason}</td>
              <td>{vote.createdOn}</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  };

  const contents = loading
    ? <p><em>Loading...</em></p>
    : renderVotesTable(votes);

  return (
    <div>
      <h1 id="tabelLabel">Votes</h1>
      <p>This component demonstrates fetching data from the server.</p>
      {contents}
    </div>
  );
};
